module.exports = __webpack_public_path__ + "img/icon-arrow-right-blue.2de229bd.svg";